import { useTranslation } from 'react-i18next';
import { AppLayout } from '@/ui/layouts';
import { PageTitle, PairingHelpView } from '@/ui/components';

/**
 * PairingHelpPage - Instructions for pairing NFC items
 *
 * Displays step-by-step instructions for scanning and pairing NFC products.
 * Uses AppLayout for consistent navigation and responsive behavior.
 *
 * Route: /pairing-help
 */
export default function PairingHelpPage() {
  const { t } = useTranslation();

  return (
    <AppLayout>
      <PageTitle>{t('pairingHelp.title', 'Scan a new item')}</PageTitle>
      <PairingHelpView />
    </AppLayout>
  );
}
